import { memo } from 'react';
import { TextField } from 'react-admin';
import { Theme } from '@mui/material/styles';

import { IconHelper } from 'components/generic/IconHelper';
import { isAssetTypeEditorEnabled } from 'utility/functions';
import { EditorialAssetSearchResultItem } from 'utility/types/dataProvider';

type TitleFieldProps = {
  record: EditorialAssetSearchResultItem;
};

const TitleField = memo(({ record }: TitleFieldProps) => {
  const isDisabled = !isAssetTypeEditorEnabled(record.type);

  return (
    <>
      <IconHelper
        iconType={record.type}
        svgIconProps={{ style: { height: 16, marginRight: 1 } }}
      />

      <TextField
        source="title"
        record={{ title: record.title }}
        sx={(theme: Theme) => ({
          color: isDisabled ? theme.palette.text.disabled : theme.palette.text.primary,
        })}
      />
    </>
  );
});

export default TitleField;
